<template>
  <div class="summary">
    <div
      v-if="wingtime != ''"
      class="wing-timer"
    >
      Current Lap: {{ wingtime }}
    </div>
    <div
      v-if="runresult.length != 0"
      class="bar-chart"
    >
      <BarChart :chart-data="chartData" />
    </div>
    <table class="summary-table">
      <thead>
        <tr>
          <th colspan="3">
            Results
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Start Time</td>
          <td>Lap</td>
          <td>Del</td>
        </tr>
        <tr
          v-for="result in computedResultArr"
          :key="result.start"
        >
          <td>{{ formatDate(result.start) }}</td>
          <td>{{ calcTime(result.end, result.start) }}</td>
          <td>
            <font-awesome-icon
              icon="fa-solid fa-trash-can"
              @click="deleteResult(result)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import moment from 'moment'
  import BarChart from './BarChart.vue'

  export default {
    name: 'SummaryView',
    components: {BarChart},
    props: {
      runresult: {
        type: Array,
        required: true
      },
      wingtime: {
        type: String,
        default: ''
      }
    },
    emits: ['updateresult'],
    data: function(){
      return {
      }
    },
    computed: {
      chartData() {
        let labels = []
        let dataArr = []
        this.computedResultArr.forEach(element => {
          labels.push("")
          dataArr.push(element.end - element.start)
        });
        return {
          labels: labels,
          datasets: [ { data: dataArr } ]
        }
      },
      computedResultArr: {
        get() {
          return this.runresult
        },
        set(newVal) {
          this.$emit('updateresult', newVal)
        }
      }
    },
    methods: {
      formatDate:function(millisec){
        return moment(millisec).format("YYYY-MM-DD HH:mm:ss")
      },
      calcTime:function(after, before=0){
        const time  = (after - before)
        const millisec = time%1000
        const sec      = Math.floor(time/1000)%60
        const min      = Math.floor(time/1000/60)
        const timeStr = min + ':' + ( '00' + sec ).slice( -2 ) + ':' + ( '000' + millisec ).slice( -3 )
        return timeStr
      },
      deleteResult:function(delObj){
        const newArr = this.computedResultArr.filter((result) => {
          return result.start != delObj.start || result.end != delObj.end
        })
        this.computedResultArr = newArr
      }
    }
  }
</script>

<style>
.wing-timer {
  font-size: 2em;
  width: fit-content;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 10px;
  background-color: rgba(255,255,255,0.95);
}

table, th, td {
  border: 1px #000000 solid;
}

.summary-table {
  padding: 20px;
  width: 94vw;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgba(255,255,255,0.9);
}

td {
  padding-left: 0.6em;
  padding-right: 0.6em;
}

.bar-chart {
  padding: 20px;
  height: 300px;
  width: calc(94vw - 40px);
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: rgba(255,255,255,0.95);
  border:1px solid black;
}
</style>